$(() => {
  const $timelineWrapper = $('.timeline-wrapper'),
    $scroller = $timelineWrapper.find('.timeline-inner');
  const clickUp = () => {
    const scrollValue = $scroller.scrollTop() - 200;
    $scroller.animate({
      scrollTop: scrollValue
    }, 800);
  };
  const clickDown = () => {
    const scrollValue = $scroller.scrollTop() + 200;
    $scroller.animate({
      scrollTop: scrollValue
    }, 800);
  };
  $timelineWrapper.find('.btn-up').click((e) => {
    clickUp();
  });
  $timelineWrapper.find('.btn-down').click((e) => {
    clickDown();
  });

  let timeLine = [];
  $timelineWrapper.find('.timeline__content').each((index, element) => {
    $(element).addClass(index % 2 === 0 ? 'odd' : 'even');
    timeLine.push($(element));
    return timeLine;
  });

  const contentAppend = () => {
    const winWidth = document.documentElement.clientWidth;
    if (winWidth > 991) {
      $('.timeline').html('').append('<div class="left-side"></div><div class="right-side"></div>');
      $.each(timeLine, (index, value) => {
        if (index % 2 === 0) {
          $('.left-side').append(timeLine[index]);
        } else {
          $('.right-side').append(timeLine[index]);
        }
      });
    } else {
      $('.timeline').html('').append(timeLine);
    }
  };
  contentAppend();

  $(window).on("resize", () => {
    contentAppend();
  });

  $timelineWrapper.find('.btn-up').addClass('disabled');
  $scroller.scroll((e) => {
    const $this = $(e.target);
    if ($this.scrollTop() + $this.innerHeight() >= $this[0].scrollHeight) {
      $this.parent().find('.btn-down').addClass('disabled');
    } else {
      $this.parent().find('.btn-down').removeClass('disabled');
    }
    if ($this.scrollTop() == 0) {
      $this.parent().find('.btn-up').addClass('disabled');
    } else {
      $this.parent().find('.btn-up').removeClass('disabled');
    }
  });

});